import { render, staticRenderFns } from "./MyCourse.vue?vue&type=template&id=838bd9f4"
import script from "./MyCourse.vue?vue&type=script&lang=js"
export * from "./MyCourse.vue?vue&type=script&lang=js"
import style0 from "./MyCourse.vue?vue&type=style&index=0&id=838bd9f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports